import { Component } from '@angular/core';

@Component({
  selector: 'app-merchnat-main',
  templateUrl: './merchnat-main.component.html',
  styleUrls: ['./merchnat-main.component.css']
})
export class MerchnatMainComponent {
  english:boolean=true;
  hindi:boolean=false;
  ngOnInit(): void {
    const storeVal = localStorage.getItem('selectedValue');
    if (storeVal == 'english') {
      this.english = true;
      this.hindi = false;
    }
    if (storeVal == 'hindi') {

      this.english = false;
      this.hindi = true;
    }

  }
}
